module.exports = __webpack_public_path__ + "static/media/location.fcdabd08.svg";